<template>
	<div
		class="couchmode-close"
		@click.stop="$emit('close-couch-mode')"
	>
		<Icon
			class="couchmode-close__logo"
			icon-name="couch-mode-logo"
		/>
		<button class="couchmode-close__button">
			<Icon
				icon-name="e-remove"
				size="xl"
			/>
		</button>
	</div>
</template>

<script>

import Icon from '@shared/components/Icon';

export default {
	name:       'CouchModeClose',
	components: { Icon },
};

</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.couchmode-close {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	padding-left: 24px;
	padding-right: 24px;
	padding-top: 24px;
	gap: 16px;
	cursor: pointer;
}

.couchmode-close__logo {
	height: 24px !important; // stylelint-disable-line declaration-no-important
	width: 110px !important; // stylelint-disable-line declaration-no-important
}

//.couchmode-close__button {}
</style>
